var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 682.67 682.67",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    "data-original": "#000000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 682.67)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(0 256)",
    d: "M0 0c0 141.385 114.615 256 256 256S512 141.385 512 0c0-110.457-69.956-204.575-167.979-240.466C316.575-250.515 286.928-229.5 256-229.5c-23.088 0-69.193-17.04-69.602-16.925C78.837-216.105 0-117.259 0 0",
    fill: "#9d45b9",
    "data-original": "#9331b2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(512 256)",
    d: "M0 0c0 17.205-1.71 34.008-4.946 50.261l-102.559 102.56-23.727 14.708-30.524-49.239-80.286 80.025h-27.916V118.29l29.806-26.936a25.17 25.17 0 0 1-5.268-3.258c-4.77 5.219-11.593 8.272-18.714 8.272-6.052 0-11.756-2.1-16.314-5.962-4.795 4.999-11.372 7.805-18.387 7.764a24.64 24.64 0 0 1-10.892-2.599l-71.041 71.958-23.727-14.708 42.165-68.015 34.504-36.59a7.84 7.84 0 0 1-2.134 1.007c-7.224 2.117-15.582-1.726-19.302-6.425-10.393-13.129-4.128-39.782-4.06-40.101 7.062-32.954 33.512-58.302 40.768-64.956.474-.516.942-1.02 1.399-1.506v-17.173h-14.436v-165.489c.246-.069 36.091 16.927 69.591 16.927 33.5 0 62.311-20.689 90.428-10.071C-68.813-203.03 0-109.551 0 0",
    fill: "#9d45b9",
    "data-original": "#681f7b"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(173.4 355.51)",
    d: "m0 0-23.726-14.708-42.164 68.015 23.726 14.708z",
    fill: "#fff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(338.6 355.51)",
    d: "m0 0 23.726-14.708L65.89 53.307 42.164 68.015Z",
    fill: "#fff5cb",
    "data-original": "#fff5cb"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m269.96 374.29h-27.915v80.024h27.915z",
    fill: "#fff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M269.96 374.29H256v80.02h13.96z",
    fill: "#fff5cb",
    "data-original": "#fff5cb"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(340.79 324.15)",
    d: "M0 0c-3.462 9.163-11.772 15.785-21.531 16.63-5.397.468-10.616-.722-15.138-3.4-4.541 7.541-12.789 12.285-21.7 12.285-5.821 0-11.357-1.961-15.838-5.569-4.769 5.219-11.592 8.272-18.713 8.272-6.052 0-11.756-2.1-16.314-5.961-4.795 4.998-11.372 7.804-18.388 7.763-14.009-.081-25.162-11.84-25.162-25.85v-28.356c-1.512 2.497-3.465 4.527-5.962 5.259-7.224 2.117-15.582-1.726-19.302-6.425-10.393-13.128-4.128-39.782-4.06-40.1 7.646-35.677 38.033-62.457 42.167-66.232v-48.636H-8.507v56.698c0 6.369.237 12.736.712 19.087L.018-.048Z",
    fill: "#ffdba9",
    "data-original": "#ffdba9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(340.8 324.1)",
    d: "m0 0-7.81-104.49c-.47-6.35-.71-12.72-.71-19.09v-56.69H-84.8V26.9c4.02-1.36 7.68-3.74 10.58-6.91 4.48 3.61 10.02 5.57 15.84 5.57 8.91 0 17.16-4.74 21.7-12.28 4.52 2.67 9.74 3.86 15.14 3.4C-11.79 15.83-3.48 9.21-.01.05z",
    fill: "#ffc473",
    "data-original": "#ffc473"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(186.41 175.17)",
    d: "m0 0v-165.6c22.128-6.347 45.469-9.573 69.591-9.573 31.843 0 62.304 5.805 90.428 16.429l0.015 158.63z",
    fill: "#00efd1",
    "data-original": "#00efd1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(346.44 175.06)",
    d: "m0 0-.012-158.635c-28.12-10.62-58.588-16.429-90.428-16.429V0Z",
    fill: "#00ceb4",
    "data-original": "#00ceb4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(278.89 126.67)",
    d: "M0 0c0 12.334 9.999 22.333 22.333 22.333 12.335 0 22.334-9.999 22.334-22.333 0-12.334-9.999-22.333-22.334-22.333C9.999-22.333 0-12.334 0 0",
    fill: "#008878",
    "data-original": "#008878"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrit);
export default __webpack_public_path__ + "static/media/grit.bccd45e93ba8bc0050cdbd847f694907.svg";
export { ForwardRef as ReactComponent };